<template>
  <div class="almacenes-contenedor">
    <h2 class="mb-4">Almacenes</h2>

    <div class="mb-3">
      <button @click="mostrarModal(null)" class="btn-primario">
        <i class="bi bi-plus-circle me-1"></i> Nuevo Almacén
      </button>
    </div>

    <div class="tarjeta">
      <div class="tarjeta-cuerpo">
        <div v-if="cargando" class="text-center py-5">
          <div class="spinner-border" role="status" style="color: var(--primary-main);">
            <span class="visually-hidden">Cargando...</span>
          </div>
        </div>
        <div v-else-if="almacenes.length === 0" class="alerta-info">
          No se encontraron almacenes registrados.
        </div>
        <div v-else class="table-responsive">
          <table class="tabla-datos">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nombre</th>
                <th>Principal</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="almacen in almacenes" :key="almacen.id">
                <td>{{ almacen.id }}</td>
                <td><strong>{{ almacen.nombre_almacen }}</strong></td>
                <td>
                  <span v-if="almacen.principal" class="insignia insignia-advertencia">
                    <i class="bi bi-star-fill me-1"></i> Principal
                  </span>
                  <span v-else class="texto-apagado">-</span>
                </td>
                <td>
                  <span class="insignia" :class="almacen.activo ? 'insignia-exito' : 'insignia-secundaria'">
                    {{ almacen.activo ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
                <td>
                  <div class="btn-group btn-group-sm">
                    <button @click="mostrarModal(almacen)" class="btn-accion btn-accion-editar" title="Editar">
                      <i class="bi bi-pencil"></i>
                    </button>
                    <button @click="confirmarEliminar(almacen)" class="btn-accion btn-accion-eliminar" title="Eliminar" :disabled="almacen.principal">
                      <i class="bi bi-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Modal Crear/Editar -->
    <div v-if="modalVisible" class="modal-fondo">
      <div class="modal-contenido">
        <div class="modal-encabezado">
          <h5 class="modal-titulo">{{ almacenEnEdicion ? 'Editar' : 'Nuevo' }} Almacén</h5>
          <button type="button" class="btn-close" @click="cerrarModal"></button>
        </div>
        <div class="modal-cuerpo">
          <form @submit.prevent="guardarAlmacen">
            <div class="campo-grupo">
              <label class="campo-etiqueta">Nombre *</label>
              <input v-model="formulario.nombre_almacen" type="text" class="campo-entrada" required placeholder="Nombre del almacen" />
            </div>
            <div class="campo-grupo">
              <label class="campo-verificacion">
                <input v-model="formulario.principal" type="checkbox" />
                <span>Almacén principal</span>
              </label>
              <p class="texto-ayuda">Solo puede existir un almacen principal. Activar este reemplazará al actual.</p>
            </div>
            <div class="campo-grupo">
              <label class="campo-verificacion">
                <input v-model="formulario.activo" type="checkbox" />
                <span>Activo</span>
              </label>
            </div>
          </form>
        </div>
        <div class="modal-pie">
          <button type="button" class="btn-secundario" @click="cerrarModal">Cancelar</button>
          <button type="button" class="btn-primario" @click="guardarAlmacen" :disabled="guardando">
            <span v-if="guardando" class="spinner-border spinner-border-sm me-1"></span>
            {{ guardando ? 'Guardando...' : 'Guardar' }}
          </button>
        </div>
      </div>
    </div>

    <!-- Modal Confirmar Eliminar -->
    <div v-if="almacenParaEliminar" class="modal-fondo">
      <div class="modal-contenido">
        <div class="modal-encabezado">
          <h5 class="modal-titulo">Confirmar Eliminación</h5>
          <button type="button" class="btn-close" @click="almacenParaEliminar = null"></button>
        </div>
        <div class="modal-cuerpo">
          <p>Desea eliminar el almacen <strong>{{ almacenParaEliminar.nombre_almacen }}</strong>?</p>
          <p class="texto-secundario small">Esta acción no se puede deshacer.</p>
        </div>
        <div class="modal-pie">
          <button type="button" class="btn-secundario" @click="almacenParaEliminar = null">Cancelar</button>
          <button type="button" class="btn-peligro" @click="eliminarAlmacen">Eliminar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { inventarioService } from '@/services/inventarioService';
import notificationService from '@/services/notificationService';

export default {
  name: 'ClientInventarioAlmacenes',
  data() {
    return {
      almacenes: [],
      cargando: false,
      modalVisible: false,
      guardando: false,
      almacenEnEdicion: null,
      almacenParaEliminar: null,
      formulario: { nombre_almacen: '', principal: false, activo: true }
    };
  },
  mounted() {
    this.cargarAlmacenes();
  },
  methods: {
    async cargarAlmacenes() {
      this.cargando = true;
      try {
        const respuesta = await inventarioService.getAlmacenes();
        this.almacenes = respuesta?.data || [];
      } catch (error) {
        console.error('Error al cargar almacenes:', error);
        this.almacenes = [];
      } finally {
        this.cargando = false;
      }
    },
    mostrarModal(almacen) {
      if (almacen) {
        this.almacenEnEdicion = almacen;
        this.formulario = { nombre_almacen: almacen.nombre_almacen, principal: !!almacen.principal, activo: !!almacen.activo };
      } else {
        this.almacenEnEdicion = null;
        this.formulario = { nombre_almacen: '', principal: false, activo: true };
      }
      this.modalVisible = true;
    },
    cerrarModal() {
      this.modalVisible = false;
      this.almacenEnEdicion = null;
      this.formulario = { nombre_almacen: '', principal: false, activo: true };
    },
    async guardarAlmacen() {
      if (!this.formulario.nombre_almacen.trim()) {
        notificationService.warning('El nombre del almacen es requerido');
        return;
      }
      this.guardando = true;
      try {
        if (this.almacenEnEdicion) {
          await inventarioService.updateAlmacen(this.almacenEnEdicion.id, this.formulario);
          notificationService.success('Almacén actualizado correctamente');
        } else {
          await inventarioService.createAlmacen(this.formulario);
          notificationService.success('Almacén creado correctamente');
        }
        this.cerrarModal();
        this.cargarAlmacenes();
      } catch (error) {
        console.error('Error al guardar almacen:', error);
        notificationService.error('Error al guardar el almacen');
      } finally {
        this.guardando = false;
      }
    },
    confirmarEliminar(almacen) {
      this.almacenParaEliminar = almacen;
    },
    async eliminarAlmacen() {
      try {
        await inventarioService.deleteAlmacen(this.almacenParaEliminar.id);
        notificationService.success('Almacén eliminado correctamente');
        this.almacenParaEliminar = null;
        this.cargarAlmacenes();
      } catch (error) {
        console.error('Error al eliminar almacen:', error);
        notificationService.error('Error al eliminar el almacen');
      }
    }
  }
};
</script>

<style scoped>
.almacenes-contenedor { padding: 20px; color: var(--text-primary); }
.tarjeta { background-color: var(--secondary-bg-main); border: 1px solid var(--border-main); border-radius: 8px; box-shadow: var(--shadow-sm); }
.tarjeta-cuerpo { padding: 1rem; }
.tabla-datos { width: 100%; border-collapse: collapse; }
.tabla-datos th { background-color: var(--bg-main); color: var(--text-secondary); font-weight: 600; padding: 0.75rem; border-bottom: 1px solid var(--border-main); text-align: left; }
.tabla-datos td { padding: 0.75rem; border-bottom: 1px solid var(--border-main); color: var(--text-primary); }
.tabla-datos tr:hover td { background-color: var(--bg-main); }
.alerta-info { padding: 1rem; background-color: var(--bg-main); border: 1px solid var(--border-main); border-radius: 6px; color: var(--text-secondary); }
.insignia { display: inline-block; padding: 0.25rem 0.5rem; border-radius: 4px; font-size: 0.8rem; font-weight: 500; }
.insignia-exito { background-color: var(--accent-success); color: white; }
.insignia-secundaria { background-color: var(--text-muted); color: white; }
.insignia-advertencia { background-color: var(--accent-warning); color: var(--text-primary); }
.texto-apagado { color: var(--text-muted); }
.texto-secundario { color: var(--text-secondary); }
.texto-ayuda { color: var(--text-muted); font-size: 0.8rem; margin-top: 0.25rem; }
.btn-primario { background-color: var(--primary-main); color: white; border: none; padding: 0.5rem 1rem; border-radius: 6px; cursor: pointer; }
.btn-primario:hover { background-color: var(--primary-hover); }
.btn-primario:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-secundario { background-color: var(--bg-main); color: var(--text-primary); border: 1px solid var(--border-main); padding: 0.5rem 1rem; border-radius: 6px; cursor: pointer; }
.btn-peligro { background-color: var(--accent-danger); color: white; border: none; padding: 0.5rem 1rem; border-radius: 6px; cursor: pointer; }
.btn-accion { border: none; padding: 0.25rem 0.5rem; border-radius: 4px; cursor: pointer; margin: 0 2px; }
.btn-accion-editar { background-color: var(--primary-main); color: white; }
.btn-accion-eliminar { background-color: var(--accent-danger); color: white; }
.btn-accion:hover { opacity: 0.85; }
.btn-accion:disabled { opacity: 0.4; cursor: not-allowed; }
.modal-fondo { position: fixed; inset: 0; background-color: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1050; }
.modal-contenido { background-color: var(--secondary-bg-main); border: 1px solid var(--border-main); border-radius: 8px; width: 100%; max-width: 500px; box-shadow: var(--shadow-md); }
.modal-encabezado { display: flex; justify-content: space-between; align-items: center; padding: 1rem 1.25rem; border-bottom: 1px solid var(--border-main); }
.modal-titulo { margin: 0; color: var(--text-primary); font-size: 1.1rem; }
.modal-cuerpo { padding: 1.25rem; }
.modal-pie { display: flex; justify-content: flex-end; gap: 0.5rem; padding: 1rem 1.25rem; border-top: 1px solid var(--border-main); }
.campo-grupo { margin-bottom: 1rem; }
.campo-etiqueta { display: block; margin-bottom: 0.4rem; color: var(--text-secondary); font-size: 0.9rem; }
.campo-entrada { width: 100%; padding: 0.5rem 0.75rem; background-color: var(--bg-main); border: 1px solid var(--border-main); border-radius: 6px; color: var(--text-primary); font-size: 0.95rem; box-sizing: border-box; }
.campo-entrada:focus { outline: none; border-color: var(--border-focus); box-shadow: 0 0 0 2px rgba(14,165,233,0.15); }
.campo-verificacion { display: flex; align-items: center; gap: 0.5rem; color: var(--text-secondary); cursor: pointer; }
</style>